/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.TemplateManagementAppService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

/**
 *  Cursor for custom assistants pagination
 */
export type CustomAssistantCursor = {
  offset: Default<number>;
  stringOffset?: string;
};

export type CustomAssistantError = {
  type: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

/**
 *  Request to list installations of a specific custom assistant template on the current portal.
 *  Portal ID is obtained from the ChirpContext.
 */
export type ListTemplateInstallsByGlobalIdRequest = {
  templateGlobalId: string;
  pageLength: Default<number>;
  offset: CustomAssistantCursor;
};

export type ErrorType =
  | 'HIPAA_PORTAL_ACCESS_DENIED'
  | 'PERMISSION_DENIED'
  | 'ASSISTANT_NOT_FOUND'
  | 'UPDATE_FAILURE'
  | 'INVALID_TYPE'
  | 'TEMPLATE_NOT_FOUND'
  | 'TEMPLATE_UPDATE_FAILURE'
  | 'TEMPLATE_ALREADY_INSTALLED'
  | 'TEMPLATE_HAS_ACTIVE_INSTALLATIONS'
  | 'TEMPLATE_PROMOTION_FAILURE'
  | 'INVALID_MODEL'
  | 'INVALID_METADATA'
  | 'WRONG_HUBLET'
  | 'FEATURE_NOT_AVAILABLE'
  | unhandledEnumCase;

/**
 *  Represents a custom assistant template installation on a portal.
 *  Contains information about which portal has the template installed and when.
 */
export type CustomAssistantTemplateInstall = {
  portalId: number;
  customAssistantId: number;
  templateGlobalId: string;
  installedAt: number;
  installedBy: number;
};

/**
 *  Response for listing installations of a specific custom assistant template
 */
export type ListTemplateInstallsResponse = {
  results: Default<CustomAssistantTemplateInstall[]>;
  offset: CustomAssistantCursor;
  hasMore: boolean;
};

export type ListTemplateInstallsByGlobalIdRequestType =
  Requestify<ListTemplateInstallsByGlobalIdRequest>;
export type ListTemplateInstallsByGlobalIdResponseType =
  ListTemplateInstallsResponse;
export type ListTemplateInstallsByGlobalIdErrorType = CustomAssistantError &
  HubspotMetadata;
export const listTemplateInstallsByGlobalIdRpc: ChirpAvroRpcDetails<
  ListTemplateInstallsByGlobalIdRequestType,
  ListTemplateInstallsByGlobalIdResponseType,
  ListTemplateInstallsByGlobalIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.customassistants.rpc.TemplateManagementAppService',
  rpcName: 'listTemplateInstallsByGlobalId',
  auth: 'app',
  fingerprint: 'mpQo-2gDAI7P3AGo20fi9janqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
